export default __webpack_public_path__ + "static/home_1-acfb10a1d05023aaf66cd001087be4d3.png";